import { pendingTask, begin, end } from 'react-redux-spinner';
import toastr from 'toastr';
import * as Types from '../action-types';
import InventoryService from '../../services/inventory-service';
import serviceUtils from '../../utils/service-utils';
import InventoryUtils from '../../utils/inventory-utils';
import Inventory from '../../components/models/inventory';
import { error } from 'jquery';

let inventoryActions = {
    setInventory: function(inventory) {
        return (dispatch, getState) => {
            dispatch({
                type: Types.SET_INVENTORY,
                response: inventory.inventory
            });
            return new Promise((resolve) => {
                resolve(inventory);
            });
        };
    },
    setModelObject: function(value) {
        return (dispatch, getState) => {
            dispatch({
                type: Types.SET_MODEL_OBJECT,
                inventoryObject: value
            });
            return new Promise((resolve) => {
                resolve(value);
            });
        };
    },
    setInventoryData: function(inventoryData) {
        return (dispatch, getState) => {
            dispatch({
                type: Types.SET_INVENTORYDATA,
                inventoryData: inventoryData
            });
            return new Promise((resolve) => {
                resolve(inventoryData);
            });
        };
    },

    checkInventoryExists: function(model) {
        return (dispatch, getState) => {
            dispatch(inventoryActions.checkInventoryBegin());
            let service = new InventoryService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return service
                .checkInventoryExist(model)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(
                        response,
                        'Server Error : Unable to contact the inventory service.'
                    );
                })
                .then((data) => {
                    dispatch(inventoryActions.checkInventorySuccess(data));
                    return data;
                })
                .catch((error) => {
                    dispatch(inventoryActions.checkInventoryError(error));
                    serviceUtils.processErrors(error);
                    Promise.reject(error);
                });
        };
    },
    checkInventoryBegin: function() {
        return {
            type: Types.INVENTORY_CHECK_BEGIN,
            [pendingTask]: begin
        };
    },
    checkInventorySuccess: function(data) {
        return {
            type: Types.INVENTORY_CHECK_SUCCESS,
            response: data,
            [pendingTask]: end
        };
    },
    checkInventoryError: function(error) {
        return {
            type: Types.INVENTORY_CHECK_ERROR,
            error: error,
            [pendingTask]: end
        };
    },

    saveInventory: function(model) {
        return (dispatch, getState) => {
            dispatch(inventoryActions.saveInventoryBegin());
            let service = new InventoryService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return service
                .save(model)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(
                        response,
                        'Server Error : Unable to contact the inventory service.'
                    );
                })
                .then((data) => {
                    if (data.isValid) {
                        toastr.success('Record has been saved');
                        const modResp = { ...getState().model, inventory: data.inventory, liveAvailabilityList: data.liveAvailabilityList }
                        dispatch(inventoryActions.saveInventorySuccess(modResp));
                        return data;
                    } else {
                        dispatch(inventoryActions.saveInventoryError(data.errors));
                        serviceUtils.processErrors(data.errors);
                        Promise.reject('Could not save.');
                    }
                })
                .catch((error) => {
                    dispatch(inventoryActions.saveInventoryError(error));
                    serviceUtils.processErrors(error);
                    Promise.reject(error);
                });
        };
    },
    saveInventoryBegin: function() {
        return {
            type: Types.INVENTORY_SAVE_BEGIN,
            [pendingTask]: begin
        };
    },
    saveInventorySuccess: function(data) {
        return {
            type: Types.INVENTORY_SAVE_SUCCESS,
            response: data,
            [pendingTask]: end
        };
    },
    saveInventoryError: function(error) {
        return {
            type: Types.INVENTORY_SAVE_ERROR,
            error: error,
            [pendingTask]: end
        };
    },

    searchInventory: function(request, level) {
        return (dispatch, getState) => {
            dispatch(inventoryActions.searchInventoryBegin());
            let service = new InventoryService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return service
                .search(request)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(
                        response,
                        'Server Error : Unable to contact the inventory service.'
                    );
                })
                .then((data) => {
                    dispatch(inventoryActions.searchInventorySuccess(data, level));
                    return data;
                })
                .catch((error) => {
                    dispatch(inventoryActions.searchInventoryError(error));
                    serviceUtils.processErrors(error);
                    Promise.reject(error);
                });
        };
    },
    searchInventoryBegin: function() {
        return {
            type: Types.INVENTORY_SEARCH_BEGIN,
            [pendingTask]: begin
        };
    },
    searchInventorySuccess: function(data, level) {
        return {
            type: Types.INVENTORY_SEARCH_SUCCESS,
            response: data,
            level: level,
            [pendingTask]: end
        };
    },
    searchInventoryError: function(error) {
        return {
            type: Types.INVENTORY_SEARCH_ERROR,
            error: error,
            [pendingTask]: end
        };
    },
    resetPageOnAdd: function(inventory) {
        return (dispatch, getState) => {
            dispatch({
                type: Types.INVENTORY_RESET_PAGE_ON_ADD,
                inventory: inventory.inventory,
                inventoryData: inventory.inventoryData
            });
            return new Promise((resolve) => {
                resolve(inventory);
            });
        };
    },
    loadRequest: function(id, defaultRTvalues) {
        return (dispatch, getState) => {
            dispatch(inventoryActions.loadRequestBegin());
            let service = new InventoryService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return service
                .get(id)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(
                        response,
                        'Server Error : Unable to contact the inventory service.'
                    );
                })
                .then((data) => {
                    if (data) {
                        const rooms = InventoryUtils.getRoomTypesFromHotel(
                            data.inventory.hotel,
                            {
                                value: data.inventory.roomCategoryId,
                                label: data.inventory.roomCategoryName
                            },
                            defaultRTvalues
                        );
                        const emptyObj = new Inventory();
                        let alteredData = {
                            ...emptyObj,
                            ...data,
                            allocationRooms: rooms,
                            freesaleRooms: rooms
                        };
                        dispatch(inventoryActions.loadRequestSuccess(alteredData));
                        return data;
                    } else {
                        Promise.reject('Empty service response. No data available.');
                    }
                })
                .catch((error) => {
                    dispatch(inventoryActions.loadRequestError(error));
                    toastr.error('Could not load inventory, service unavaliable.');
                    Promise.reject(error);
                });
        };
    },
    loadRequestBegin: function() {
        return {
            type: Types.LOAD_REQUEST_BEGIN,
            results: null,
            [pendingTask]: begin
        };
    },
    loadRequestSuccess: function(data) {
        return {
            type: Types.INVENTORY_GET_SUCCESS,
            response: data,
            [pendingTask]: end
        };
    },
    loadRequestError: function(error) {
        return {
            type: Types.LOAD_REQUEST_ERROR,
            error: error,
            results: null,
            [pendingTask]: end
        };
    }
};

export default inventoryActions;
